import React, { useState } from "react";
import { rbac } from "../index";
import t from "../../../helpers/t";
import { productsActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";

const SortButtons = (props) => {
  const [product, setProduct] = useState(props.product);
  let secondClass = props.product.sort_order > 1 ? "up_active" : "up_inactive";
  let firstClass = props.product.sort_order < props.last ? "down_active" : "down_active"; // we make all active
  const changeSort = (e) => {
    let clone = {};
    Object.assign(clone, product);
    switch (e.currentTarget.name) {
      case "up":
        clone.sort_order += 1;
        break;
      case "down":
        clone.sort_order -= 1;
        break;
      case "input":
        clone.sort_order = Number(e.currentTarget.value);
        break;
    }
    setProduct(clone);
    setTimeout(() => {
      props.setProduct(clone);
    }, 10);
    props.dispatch(
      productsActions.patchProduct({
        id: Number(product.id),
        body: {
          sort_order: clone.sort_order,
        },
        token: Biscuit.get("token"),
      }),
    );
    setTimeout(() => {
      props.dispatch(
        productsActions.getProducts({
          token: Biscuit.get("token"),
          filter: { sort: "sort_order" },
        }),
      );
    }, 1000);
  };

  const changeSortInput = (e) => {
    console.log(e.currentTarget.value);
  };

  return (
    <>
      {props.standard ? (
        <>
          <table style={{ width: "30%", minWidth: "79px", minHeight: "35px" }}>
            <tr>
              <td style={{ width: "25%" }}>
                <a href="#" onClick={(e) => changeSort(e)} name="down" className={secondClass}>
                  {" "}
                  &nbsp;{" "}
                </a>
              </td>
              <td style={{ width: "50%" }}>
                <input
                  style={{ width: "110%" }}
                  id="sortOrder"
                  name="input"
                  value={props.product.sort_order}
                  onChange={(e) => changeSort(e)}
                />
              </td>
              <td style={{ width: "25%" }}>
                <a href="#" onClick={(e) => changeSort(e)} name="up" className={firstClass}>
                  {" "}
                  &nbsp;{" "}
                </a>
              </td>
            </tr>
          </table>
        </>
      ) : (
        <>
          <table style={{ width: "30%", minWidth: "79px", minHeight: "35px" }}>
            <tr>
              <td style={{ width: "40%" }}>
                <span>{t("position")}:</span>
              </td>
              <td style={{ width: "50%", paddingLeft: "10px" }}>
                <input
                  style={{ width: "110%", textAlign: "center" }}
                  id="sortOrder"
                  name="input"
                  value={props.product.sort_order}
                  onChange={(e) => changeSort(e)}
                />
              </td>
            </tr>
          </table>
        </>
      )}
    </>
  );
};

export default SortButtons;
